const weddingPointsOfInterest = [
    {
        name: 'New Marlborough Meeting House',
        detail: 'Ceremony location',
        link: 'https://maps.google.com/?q=New+Marlborough+Meeting+House+New+Marlborough+MA'
    },
    {
        name: 'Old Inn on the Green',
        detail: 'Reception venue and gathering point throughout the weekend',
        link: 'https://maps.google.com/?q=Old+Inn+on+the+Green+New+Marlborough+MA'
    },
    {
        name: 'Great Barrington',
        detail: 'Guest lodging, restaurants, coffee shops, groceries, and more',
        link: 'https://maps.google.com/?q=Great+Barrington+MA'
    },
    {
        name: 'Mill River House',
        detail: 'Sunday farewell brunch location',
        link: 'https://www.google.com/maps/place/779+Mill+River+Great+Barrington+Rd,+New+Marlborough,+MA+01230'
    },
    {
        name: 'Monument Mountain Trailhead',
        detail: 'Friday morning hike location',
        link: 'https://maps.google.com/?cid=15739336652632621825'
    }
];

export default weddingPointsOfInterest;
